import type { ResourceProps } from 'react-admin';
import { type ComponentType, lazy } from 'react';
import { resources } from '@repo/c360-ra-components';
import { CanAccess } from 'react-admin';

const AsyncPageList = lazy(() => import('./list'));
const AsyncPageShow = lazy(() => import('./show'));

const protectedList = () => (
  <CanAccess resource={resources.taReports} action="list">
    <AsyncPageList />
  </CanAccess>
);
const protectedShow = () => (
  <CanAccess resource={resources.taReports} action="show">
    <AsyncPageShow />
  </CanAccess>
);
export default {
  list: protectedList as ComponentType<any>,
  show: protectedShow as ComponentType<any>,
} as ResourceProps;
